export default __webpack_public_path__ + "static/media/icon-downloadWhite.29efb196.svg";